import * as tslib_1 from "tslib";
import { Injector, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { FeatureFlag, } from '@models';
import UiValidators from '@validators';
var CONTROLS = [
    {
        placeholder: 'screen_recording_form_quality',
        name: 'quality',
        min: 25,
        max: 100,
        default: 100,
    },
    {
        placeholder: 'screen_recording_form_frequency',
        name: 'frequency',
        min: 250,
        max: 10000,
        default: 500,
    },
    {
        placeholder: 'screen_recording_form_duration',
        name: 'duration',
        min: 1,
        max: 120,
        default: 40,
    },
];
var ProcessSettingsComponent = /** @class */ (function () {
    function ProcessSettingsComponent(fb, _injector) {
        this._injector = _injector;
        this.controls = CONTROLS;
        this._appState = this._injector.get(AppStateFacade);
        var controls = CONTROLS.reduce(function (acc, curr) {
            acc[curr.name] = [
                curr.default,
                Validators.compose([
                    UiValidators.required(),
                    UiValidators.range(curr.min, curr.max, true),
                ]),
            ];
            return acc;
        }, {});
        this.form = fb.group(tslib_1.__assign({ enabled: false, autoStartProcess: false }, controls));
    }
    Object.defineProperty(ProcessSettingsComponent.prototype, "isMediaRecordingEnabled", {
        get: function () {
            return this._appState.settings.isFeatureEnabled(FeatureFlag.MediaRecording);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcessSettingsComponent.prototype, "isAutoStartEnabled", {
        get: function () {
            return this._appState.settings.isFeatureEnabled(FeatureFlag.ProcessSettingAutoStart);
        },
        enumerable: true,
        configurable: true
    });
    ProcessSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var mapState = this.state || {};
        Object.keys(mapState).forEach(function (key) {
            var value = mapState[key];
            if (value != null) {
                _this.form.get(key).setValue(value);
            }
        });
    };
    return ProcessSettingsComponent;
}());
export { ProcessSettingsComponent };
